import { Collapse, type CollapseProps } from "antd";
import { SvgArrowDown, SvgArrowUp } from "components/svg";
import { useGetFAQQuery } from "store/api";
import useTranslation from "utils/hooks/useTranslation";

export const FAQPage: React.FC = () => {
  const { data: FAQData } = useGetFAQQuery(null);
  const { language, convertToHtml } = useTranslation();

  const items: CollapseProps["items"] = (FAQData as Array<FAQData>)?.map((i: FAQData) => ({
    key: i.id,
    label: language === 'fr' ? i.question_fr : i.question_en,
    children: <group data-direction="column" >{convertToHtml(language === 'fr' ? i.answer_fr : i.answer_en, '\n')}</group>,
  }));

  const faqList = <group data-direction="column">
            <Collapse items={items} 
            expandIconPosition={"end"}
                    expandIcon={({ isActive }) => (
                      isActive ? <icon data-svg-size="70" data-min-length="70" data-svg-color="secondary"><SvgArrowUp /></icon> : <icon data-svg-size="70" data-min-length="70" data-svg-color="secondary"><SvgArrowDown /></icon>
                    )}
            />
          </group>;

  return (
    <group>
      <group data-align="center" data-direction="column" data-gap="20">
        <group
          data-gap="40"
          //data-space-vertical="10"
          data-wrap="no"
          data-max-length="1440"
          data-adaptive="desktop"
        >
          {faqList}
        </group>

        <group
          data-gap="40"
          //data-space-vertical="10"
          data-wrap="no"
          data-max-length="1440"
          data-space-horizontal="20"
          data-adaptive="mobile"
        >
          {faqList}
        </group>
      </group>
    </group>
  );
};
